<script setup lang="ts">
    import { ref, provide } from 'vue';
    definePageMeta({
        middleware: ['auth'],
        meta: [{ name: 'robots', content: 'index, nofollow' }],
    });

    import { useAuthStore } from '@whaleden/core/store/auth';

    const authStore = useAuthStore();

    const trimmedUsername = computed(() => {
        if (authStore.user && authStore.user.preferred_username) {
            return authStore.user.preferred_username.split('@')[0];
        }
        return '';
    });

    const { locale } = useI18n();

    // Provide a shared state for open popover
    const openPopover = ref(null);
    provide('openPopover', openPopover);

    const { $keycloak } = useNuxtApp();

    const signup = () => {
        const redirectUri =
            locale.value && locale.value !== 'en'
                ? `${window.location.origin}/${locale.value}/account'`
                : `${window.location.origin}/account`;
        $keycloak.register({ redirectUri });
    };

    const signin = () => {
        const redirectUri =
            locale.value && locale.value !== 'en'
                ? `${window.location.origin}/${locale.value}/account`
                : `${window.location.origin}/account`;
        $keycloak.login({ redirectUri, locale: locale.value });
    };

    definePageMeta({
        middleware: ['auth'],
        meta: [{ name: 'robots', content: 'index, nofollow' }],
    });
</script>

<template>
    <div class="block lg:mt-0 lg:mr-4">
        <div class="flex items-center space-x-4">
            <div class="z-20 xl:hidden lg:flex space-y-8 lg:space-y-0 right-4 top-4" v-if="!$keycloak?.authenticated">
                <div
                    class="shadow-2xl shadow-black/80 cursor-pointer text-base md:text-base text-white hover:text-[#00c2ff] font-bold cta-button-secondary duration-500 transition-all secondary rounded-md"
                >
                    <a class="secondary" @click="signin">{{ $t('header.sign_in') }}</a>
                </div>
            </div>

            <div
                v-if="$keycloak?.authenticated"
                class="flex xl:hidden justify-center px-4 py-1 items-center from-slate-700 bg-gradient-to-r to-slate-800 rounded-full cursor-pointer hover:text-[#00c2ff] duration-300 transition-all ease"
            >
                <NuxtLinkLocale class="" to="/account">
                    <FontAwesomeIcon class="w-3.5 h-3.5 mr-1.5" :icon="['fas', 'user']" />
                    {{ trimmedUsername }}</NuxtLinkLocale
                >
            </div>
            <div v-if="!$keycloak?.authenticated" class="overflow-hidden mt-0.5 hidden xl:block">
                <div
                    @click="signin"
                    class="flex justify-center px-4 pt-1.5 pb-1 items-center from-slate-700 bg-gradient-to-r to-slate-800 rounded-full cursor-pointer hover:text-[#00c2ff] duration-300 transition-all ease"
                >
                    <FontAwesomeIcon
                        class="w-4 h-4 mr-1.5 -mt-0.5 cursor-pointer"
                        :icon="['fas', 'arrow-right-to-bracket']"
                    />
                    <span class="whitespace-nowrap font-semibold">{{ $t('header.sign_in') }}</span>
                </div>
            </div>
            <div v-else class="mt-0.5 hidden xl:block">
                <div
                    class="flex justify-center px-4 pt-1.5 pb-1 items-center from-slate-700 bg-gradient-to-r to-slate-800 rounded-full cursor-pointer hover:text-[#00c2ff] duration-300 transition-all ease"
                    @click="
                        () => {
                            $router.push(locale && locale !== 'en' ? `/${locale}/account` : '/account');
                        }
                    "
                >
                    <FontAwesomeIcon class="w-3.5 h-3.5 mr-1.5" :icon="['fas', 'user']" />
                    <span class="whitespace-nowrap font-semibold"> {{ trimmedUsername }}</span>
                </div>
            </div>
            <!--   <HeaderSignInPopover class="mt-0.5 hidden xl:block" /> -->
            <AppLanguageSwitcher bold class="hidden mt-0.5 text-sm xl:block" />
        </div>
    </div>
</template>

<style scoped></style>
